import { limit } from 'app/core/factory-yup';

import { EmailRequired, ObjectRequired, StringRequired } from '../../../../core/validations/common';

import { type TaxpayerFieldValidationRule } from './index';
import { RequiredForBusiness, RequiredForIndividual } from './val-request-common';

export const rulesContactData: Array<TaxpayerFieldValidationRule> = [
  {
    validation: {
      personType: ObjectRequired,
      taxpayerName: StringRequired.max(limit.maxName),
      email: EmailRequired.max(limit.maxEmail),
      tradeName: RequiredForBusiness.max(limit.maxName)
    }
  },
  {
    field: 'contactCountry',
    validation: {
      country: ObjectRequired
    }
  },
  {
    field: 'contactTaxNumber',
    validation: {
      taxNumber: RequiredForBusiness.max(limit.maxCode)
    }
  },
  {
    field: 'contactIdentification',
    validation: {
      identification: RequiredForIndividual.max(limit.maxCode)
    }
  },
  {
    field: 'contactPhoneNumber',
    validation: {
      phoneNumberArea: StringRequired.max(limit.maxPhoneNumberArea),
      phoneNumber: StringRequired.max(limit.maxCode)
    }
  },
  {
    field: 'contactAddress',
    validation: {
      address: StringRequired.max(500)
    }
  },
  {
    field: 'contactCity',
    validation: {
      city: StringRequired.max(limit.maxName)
    }
  },
  {
    field: 'contactZipCode',
    validation: {
      zipCode: StringRequired.max(limit.maxCode)
    }
  },
  {
    field: 'contactPoliticalDivision',
    validation: {
      politicalDivision: ObjectRequired
    }
  }
];
